import validations from "./Validation";

export default validations;